module.exports = __webpack_public_path__ + "static/media/logo-t.83e02731.svg";